import { SET_PRODUCTS, SET_MODEL } from "./constants";
import { updateField } from "vuex-map-fields";
export default {
	[SET_PRODUCTS]: (state, payload) => (state.products = payload),
	[SET_MODEL]: (state, payload) => (state.model = payload),
	updateField
};
